@if (resposta(); as recibo) {
  <section class="confirmacao" aria-labelledby="confirmacao-titulo">
    <div class="confirmacao-topo">
      <div>
        <h2 class="confirmacao-titulo" id="confirmacao-titulo">Solicitação registrada</h2>
        <p class="confirmacao-texto">Guarde o protocolo: ele é a forma de acompanhar a sua solicitação.</p>
      </div>

      <span class="confirmacao-situacao confirmacao-situacao-registrada">
        <span class="confirmacao-situacao-ponto" aria-hidden="true"></span>
        {{ recibo.desStatusSsv }}
      </span>
    </div>

    <div class="confirmacao-protocolo" role="status" aria-live="polite">
      <span class="confirmacao-protocolo-rotulo">Número do protocolo</span>
      <strong class="confirmacao-protocolo-valor">{{ recibo.desProtocoloSsv }}</strong>
    </div>

    <dl class="confirmacao-lista">
      @for (item of linhasRecibo(); track item.rotulo) {
        <div class="confirmacao-item">
          <dt>{{ item.rotulo }}:</dt>
          <dd>{{ item.valor }}</dd>
        </div>
      }
    </dl>

    <div class="confirmacao-recibo-acoes">
      <button type="button" class="confirmacao-botao confirmacao-botao-primario" (click)="salvarPdf()">
        <i-lucide name="download" size="16" aria-hidden="true"></i-lucide>
        Baixar comprovante
      </button>

      <a class="confirmacao-botao" routerLink="/acompanhamento">
        <i-lucide name="search" size="16" aria-hidden="true"></i-lucide>
        Acompanhar solicitação
      </a>

      <button type="button" class="confirmacao-botao" (click)="novaSolicitacao.emit()">
        <i-lucide name="plus" size="16" aria-hidden="true"></i-lucide>
        Nova solicitação
      </button>
    </div>
  </section>
} @else {
  <section class="confirmacao" aria-labelledby="confirmacao-titulo">
    <div class="confirmacao-topo">
      <div>
        <h2 class="confirmacao-titulo" id="confirmacao-titulo">
          {{ exigeAgendamento() ? 'Confirmação do atendimento' : 'Confirmação da solicitação' }}
        </h2>
        <p class="confirmacao-texto">
          Verifique os dados abaixo e confirme {{ exigeAgendamento() ? 'seu agendamento' : 'sua solicitação' }}.
        </p>
      </div>

      <span class="confirmacao-situacao">
        <span class="confirmacao-situacao-ponto" aria-hidden="true"></span>
        Aguardando confirmação
      </span>
    </div>

    @if (store.erroEnvio(); as erro) {
      <div class="confirmacao-erro" role="alert">
        <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
        <div>
          <p class="confirmacao-erro-mensagem">{{ erro.mensagem }}</p>
          @if (erro.detalhes.length) {
            <ul class="confirmacao-erro-detalhes">
              @for (detalhe of erro.detalhes; track $index) {
                <li>{{ detalhe }}</li>
              }
            </ul>
          }
        </div>
      </div>
    }

    <dl class="confirmacao-lista">
      @for (item of resumo(); track item.rotulo) {
        <div class="confirmacao-item">
          <dt>{{ item.rotulo }}</dt>
          <dd>{{ item.valor }}</dd>
        </div>
      }
    </dl>

    <div class="confirmacao-campo">
      <label class="confirmacao-rotulo" for="confirmacao-observacoes">Observações (opcional)</label>
      <textarea
        id="confirmacao-observacoes"
        class="confirmacao-textarea"
        rows="4"
        placeholder="Inclua alguma informação que ajude no atendimento..."
        [formField]="confirmacaoForm.observacoes"
      ></textarea>
      <p class="confirmacao-contador">{{ caracteresObservacoes() }}/{{ limiteObservacoes }}</p>
    </div>
  </section>

  <div class="mt-3">
    <label class="confirmacao-declaracao">
      <input
        type="checkbox"
        class="confirmacao-declaracao-check"
        [checked]="store.declaracaoAceita()"
        (change)="alternarDeclaracao($event)"
      />
      Ao confirmar, você declara que as informações {{ exigeAgendamento() ? 'do agendamento' : 'da solicitação' }} estão corretas.
    </label>

    @if (exigeAgendamento()) {
      <span class="confirmacao-vaga">
        <i-lucide name="badge-check" size="16" aria-hidden="true"></i-lucide>
        Vaga garantida mediante confirmação
      </span>
    }
  </div>
}
